import React, { FunctionComponent } from 'react';
import type { Props } from './types';

export const Presentation: FunctionComponent<Props> = ({ companies }) => {
  return (
    <section className="sitetop-pickup" id="pickup">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          PICK UP<span className="sitetop-pickup-sub">注目のファッション企業</span>
        </h2>
        <a
          href="/companies"
          className="sitetop-pickup-companies gtm-button-view-count"
          data-event-name="button on screen"
          data-event="click"
          data-category="topcontent"
          data-value="pickup_companies_to_all"
        >
          企業一覧へ
        </a>
      </div>
      <div className="sitetop-pickup-container">
        {companies.map((c) => (
          <a
            key={c.companyId}
            href={`/companies/${c.companyId}`}
            className="sitetop-pickup-container-inner"
            data-event="click"
            data-category="topcontent"
            data-value="pickup_companies"
          >
            <img
              className="sitetop-pickup-container-inner-img"
              src={c.companyIcon}
              alt={`${c.companyName}のアイコン画像`}
              width="200"
              height="200"
            />
            <p className="sitetop-pickup-container-inner-name">{c.companyName}</p>
          </a>
        ))}
      </div>
      <a
        href="/companies"
        className="sitetop-pickup-spcompanies"
        data-event="click"
        data-category="topcontent"
        data-value="pickup_companies"
      >
        企業一覧へ
      </a>
    </section>
  );
};
